import React from "react";
import Select from "react-select";

import styled from "styled-components";

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: "5px",
    borderColor: "#87cdf1",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "1rem",
    // display: "none"
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "1rem",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "36px",
    overflow: "inherit",
  }),
  Input: (provided) => ({
    ...provided,
    height: "unset",
  }),
  menu: (provided) => ({
    ...provided,
    position: "absolute",
    textAlign: "left",
    zIndex: "2",
  }),
};

const DropDown = ({ name, placeholder, className, data, searchDropDown, searchable, disabled, onChangeHandler }) => {
  return (
    <InputContainer className={className}>
      <div className="input-container">
        <Select
          className={"react-select-container"}
          name={name}
          value={data.filter((option) => option.value === searchDropDown)}
          options={data}
          isDisabled={disabled}
          classNamePrefix="react-select"
          placeholder={placeholder}
          isSearchable={searchable}
          styles={customStyles}
          maxMenuHeight={150}
          onInputChange={inputValue =>
            (inputValue.length <= 18 ? inputValue : '')
          }
          onChange={(data) => {
            onChangeHandler(data.value, data);
          }}
        />

        {/* <label className={"filled"} htmlFor={name}>
          {placeholder}
        </label> */}
      </div>
    </InputContainer>
  );
};
export default DropDown;


export const InputContainer = styled.div`
  width: 100%;
  &.responsive {
    .react-select__control {
      min-height: clamp(33px, 2.292vw, 44px);
    }
   .react-select__placeholder , .react-select__single-value {
      font-size: clamp(10px, 0.729vw, 14px);
    }
    .react-select__indicator {
      padding: clamp(6px, 0.417vw, 8px);
      svg {
        height: clamp(16px, 1.042vw, 20px);
        width: clamp(16px, 1.042vw, 20px);
      }
    }
    .react-select__option {
      font-size: clamp(10px, 0.729vw, 14px);
    }
  }
  .input-container {
    position: relative;
    display: flex;
    flex-direction: column;
    input::-webkit-input-placeholder {
        color: #9c9c9c !important;
        font-size: 14px !important;
      }
  }
  .input-container:focus-within label {
    transform: translate(-12px, -9px) scale(0.8);
    /* color: #0a53e4; */
    font-size: 16px;
    line-height: 14px;
    letter-spacing: 0.005em;
    color: #70707080;
  }
  .input-container .filled {
    transform: translate(0, -9px) scale(0.8);
    /* font-size: 18px; */
    line-height: 14px;
    letter-spacing: 0.005em;
    color: #70707080;
  }
  .react-select__control {
    min-height: 44px;
    box-shadow: none;
    :hover {
      border-color: #e0e0e0;
    }
  }
  .input-container label {
    position: absolute;
    pointer-events: none;
    transform: translate(-12px, 12px) scale(1);
    transform-origin: top left;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    color: #70707080;
    font-size: 14px;
    /* line-height: 122%; */
    left: 16px;
  }
  .input-container > input {
    /* height: 64px; */
    font-family: "latomedium" !important;
    border-radius: 4px;
    border: none;
    padding: 9px 16px 9px 0;
    font-size: 16px;
    line-height: 1;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #e0e0e0;
    border-radius: 0;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  }
`;
